@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.InfoButton {
  @extend %font-family-primary;

  background: none;
  color: $theme-filter-icon-color;
  cursor: pointer;
  font-weight: $font-weight-normal;
  display: inline-block;
  line-height: 0;
  margin: 0;
  padding: 0;
  border: 0;
  height: 26px;
  width: 26px;

  &:hover {
    background: $theme-color-info-hover;
    border-radius: 2px;
    box-shadow: 0 0 0 4px $theme-color-info-hover;
  }

  &:active {
    background: $theme-color-info-active;
    border-radius: 2px;
    box-shadow: 0 0 0 4px $theme-color-info-active;
  }

  &.Focus {
    background: $theme-color-info-active;
    border-radius: 2px;
    box-shadow: 0 0 0 4px $theme-color-info-active;
  }
}
